// extracted by mini-css-extract-plugin
export default {"termsAndConBox":"termsAndCon_termsAndConBox__9E2AP"};